import url from "url"

const isDomain = (domain) => domain.match(/^([a-zA-Z](([a-zA-Z]|\d|-){0,61}([a-zA-Z]|\d))?\.)*[a-zA-Z](([a-zA-Z]|\d|-){0,61}([a-zA-Z]|\d))?$/)

export default (domain) => {
    domain = domain.replace(/^\s+/, '').replace(/\s+$/, '').toLowerCase()
    if (domain == "") {
        return null
    }
    if (isDomain(domain)) {
        return domain
    }

    const parsed = url.parse(domain)
    if (parsed !== null && parsed.hostname !== null && isDomain(parsed.hostname)) {
        return parsed.hostname
    }
    return null
}


